import { Link } from 'react-router-dom';

const stats = [
  { value: '18', label: '收录作品' },
  { value: '3', label: '内容分类' },
  { value: '6', label: '策划专题' },
  { value: '100%', label: '剧情解析' },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 rounded-lg border border-background-200 bg-background-100 p-6 md:grid-cols-2 md:p-10">
        <div>
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">ABOUT US</span>
          <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            长日光阴 · 让每一次观影都不虚度
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            我们相信，好的影视作品值得被认真对待。长日光阴专注于多元影视作品的推荐与剧情介绍，用清晰的分类、详实的解析和持续的更新，帮助每一位观众快速找到想看的内容。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            无论你是院线电影爱好者、追剧达人，还是偏爱慢综艺的生活观察者，都能在这里找到属于自己的那一部。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="flex flex-col justify-center rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{item.value}</span>
              <span className="mt-1 text-xs text-secondary-500">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}